module.exports = __webpack_public_path__ + "img/1.09450475.gif";